module.exports = __webpack_public_path__ + "img/green-square.a903cfa3.svg";